import { DashboardTranslationType } from "../../features/dashboard.types";

export const dashboard: DashboardTranslationType = {
  dashboard: {
    newStory: "新故事",
    ongoingStories: "进行中的故事",
    completedStories: "已完成的故事",
    publicStories: "公开的故事",
    loadingStory: "加载故事中",
    pleaseWait: "请稍等，我们正在加载您的故事",
    newCharacter: "新角色",
    characterCard: {
      personality: "性格",
      strengths: "优势",
      weaknesses: "劣势",
      skills: "技能"
    },
    search: {
      placeholder: "按标题搜索故事...",
      characters: "搜索角色..."
    },
    filters: {
      title: "筛选",
      reset: "重置",
      apply: "应用",
      sortBy: "排序方式",
      filterByRole: "按角色筛选",
      name: "名称",
      role: "角色",
      dateCreated: "创建日期",
      rating: "评分",
      allRoles: "所有角色",
      roles: {
        all: "所有角色",
        protagonist: "主角",
        antagonist: "反派",
        deuteragonist: "配角",
        mentor: "导师",
        comic_relief: "喜剧角色",
        mysterious: "神秘人物",
        love_interest: "恋爱对象",
        anti_hero: "反英雄",
        sidekick: "跟班",
        shapeshifter: "变形者",
        guardian: "守护者",
        catalyst: "催化剂",
        character: "角色",
        supporting: "辅助角色"
      }
    },
    deleteStory: {
      confirmTitle: "删除故事",
      confirmMessage: "您确定要删除这个故事吗？此操作无法撤销。",
      success: "故事已删除",
      successMessage: "故事已成功删除。",
      error: "错误",
      errorMessage: "删除故事失败。请重试。"
    },
    navigation: {
      stories: "故事",
      characters: "角色",
      publicStories: "公开故事",
      stats: "统计",
      more: "更多"
    },
    loadingCharacters: "加载角色中...",
    noCharactersFound: "未找到角色",
    createCharacter: {
      new: "新角色",
      title: "创建新角色",
      editTitle: "编辑角色",
      basicDetails: "基本信息",
      characteristics: "特征",
      avatarDetails: "头像详情",
      personalityTraits: "性格特点",
      form: {
        name: "名称",
        namePlaceholder: "输入角色名称",
        description: "描述",
        descriptionPlaceholder: "输入角色描述",
        role: "角色",
        selectRole: "选择角色类型",
        personality: "性格",
        personalityTraits: "性格特点",
        personalityPlaceholder: "输入性格特点",
        strengths: "优势",
        strengthsPlaceholder: "输入角色优势",
        weaknesses: "劣势",
        weaknessesPlaceholder: "输入角色劣势",
        skills: "技能",
        skillsPlaceholder: "输入角色技能",
        addTrait: "添加特点",
        addStrength: "添加优势",
        addWeakness: "添加劣势",
        addSkill: "添加技能",
        "add.Personality.Traits": "添加性格特点",
        "add.Strengths": "添加优势",
        "add.Weaknesses": "添加劣势",
        "add.Skills": "添加技能",
        unnamedCharacter: "未命名角色",
        cancel: "取消",
        create: "创建角色",
        update: "更新角色"
      },
      buttons: {
        create: "创建角色",
        update: "更新角色",
        cancel: "取消",
        updating: "更新中...",
        creating: "创建中...",
      },
      avatarGenerator: {
        genderLabel: "外观类型",
        genderPlaceholder: "选择外观类型",
        ageLabel: "年龄段",
        agePlaceholder: "选择年龄段",
        hairLabel: "头发描述",
        hairPlaceholder: "例如，长卷黑发",
        eyeLabel: "眼睛颜色",
        eyePlaceholder: "例如，深蓝色",
        clothingLabel: "服装风格",
        clothingPlaceholder: "例如，中世纪盔甲",
        expressionLabel: "面部表情",
        expressionPlaceholder: "例如，自信的微笑",
        generateButton: "生成头像",
        generating: "生成中...",
        previewLabel: "已生成头像",
        selectTitle: "选择头像",
        selectDescription: "为您的角色选择一个生成的头像。",
        partialSuccess: "部分头像生成失败",
        someImagesFailed: "部分头像生成失败。请重试。",
        selectPreferred: "选择您喜欢的头像",
        genderOptions: {
          male: "人类 - 男性",
          female: "人类 - 女性",
          // New animal options
          cat: "动物 - 猫",
          dog: "动物 - 狗",
          wolf: "动物 - 狼",
          fox: "动物 - 狐狸",
          rabbit: "动物 - 兔子",
          bird: "动物 - 鸟类",
          reptile: "动物 - 爬行动物",
          // Existing fantasy options
          elf: "奇幻 - 精灵",
          dwarf: "奇幻 - 矮人",
          orc: "奇幻 - 兽人",
          vampire: "奇幻 - 吸血鬼",
          werewolf: "奇幻 - 狼人",
          fairy: "奇幻 - 仙女",
          angelic: "奇幻 - 天使生物",
          demonic: "奇幻 - 恶魔生物",
          dragonborn: "奇幻 - 龙裔",
          centaur: "奇幻 - 半人马",
          mermaid: "奇幻 - 美人鱼/人鱼",
          humanoid_alien: "科幻 - 类人外星生物",
          insectoid_alien: "科幻 - 虫族外星生物",
          reptilian_alien: "科幻 - 爬行外星生物",
          cyborg: "科幻 - 机器人/半机械人",
          energy_being: "科幻 - 能量生命体",
          tentacled: "科幻 - 触手生物",
          cat_person: "动物 - 猫人",
          dog_person: "动物 - 犬人",
          wolf_person: "动物 - 狼人",
          fox_person: "动物 - 狐人",
          rabbit_person: "动物 - 兔人",
          bird_person: "动物 - 鸟人",
          reptile_person: "动物 - 爬行动物人",
          treant: "神话 - 树人",
          flower: "神话 - 有意识的花朵",
          vine: "神话 - 活藤蔓",
          mushroom: "神话 - 会说话的蘑菇",
          vegetable: "神话 - 动画植物",
          golem: "神话 - 魔像",
          ghost: "神话 - 鬼魂/灵体",
          shapeshifter: "神话 - 变形者"
        },
        ageOptions: {
          child: "儿童",
          teen: "青少年",
          adult: "成年人",
          elderly: "老年人"
        },
        success: {
          title: "头像已生成",
          description: "您的角色头像已成功创建。"
        },
        error: {
          title: "生成失败",
          description: "生成头像失败。请重试。"
        },
        upload: {
          button: "上传头像",
          uploading: "上传中...",
          success: {
            title: "头像已上传",
            description: "您的头像已成功上传"
          },
          error: {
            title: "上传失败",
            fileTooLarge: "头像图片必须小于5MB",
            invalidType: "请上传图片文件",
            failed: "上传头像图片失败"
          },
          loading: "加载图片中..."
        }
      },
      messages: {
        successCreated: {
          title: "角色已创建",
          description: "您的角色已成功保存。",
        },
        successUpdated: {
          title: "角色已更新",
          description: "您的角色已成功更新。",
        },
        errorLoad: {
          title: "错误",
          description: "加载角色数据失败",
        },
        errorSave: {
          title: "错误",
          description: "保存角色失败。请重试。",
        },
        validation: {
          characterName: {
            title: "缺少名称",
            description: "角色名称是必填的。",
          },
        },
      },
    },
    characterTabs: {
      myCharacters: "我的角色",
      publicCharacters: "公开角色"
    },
    characterManagement: {
      delete: {
        title: "删除角色",
        confirmMessage: "您确定要删除此角色吗？此操作无法撤销。",
        cancel: "取消",
        delete: "删除",
        deleting: "删除中...",
        success: {
          title: "角色已删除",
          description: "该角色已成功删除"
        },
        error: {
          title: "错误",
          description: "删除角色失败"
        }
      },
      visibility: {
        setPrivate: "角色设为私密",
        setPublic: "角色设为公开",
        nowPrivate: "该角色现在是私密的",
        nowPublic: "该角色现在对所有人可见",
        error: "错误",
        updateFailed: "更新角色可见性失败"
      },
      rating: {
        submitted: "评分已提交",
        thankYou: "感谢您对这个角色的评分！",
        error: "错误",
        failed: "提交评分失败"
      }
    },
    suggestions: {
      personalities: {
        adaptable: "适应性强",
        ambitious: "雄心勃勃",
        brave: "勇敢",
        charismatic: "有魅力",
        compassionate: "富有同情心",
        confident: "自信",
        creative: "创造性",
        determined: "决心",
        diplomatic: "外交的",
        empathetic: "善解人意",
        honorable: "光荣的",
        humble: "谦虚",
        humorous: "幽默",
        innovative: "创新",
        loyal: "忠诚",
        optimistic: "乐观",
        patient: "耐心",
        resilient: "坚韧",
        wise: "明智",
        analytical: "分析性",
        cautious: "谨慎",
        eccentric: "古怪",
        mysterious: "神秘",
        pragmatic: "务实",
        reserved: "含蓄",
        stoic: "坚忍不拔",
        arrogant: "傲慢",
        cynical: "愤世嫉俗",
        greedy: "贪婪",
        hot_tempered: "脾气暴躁",
        impulsive: "冲动",
        manipulative: "善于操纵",
        obsessive: "强迫症",
        paranoid: "多疑",
        prideful: "自傲",
        reckless: "鲁莽",
        ruthless: "无情",
        vengeful: "复仇心强"
      },
      skills: {
        leadership: "领导力",
        negotiation: "谈判",
        perception: "洞察力",
        persuasion: "说服力",
        investigation: "调查",
        survival: "生存",
        deception: "欺骗",
        intimidation: "恐吓",
        performance: "表演",
        medicine: "医学",
        sword_fighting: "剑术",
        archery: "射箭",
        martial_arts: "武术",
        stealth: "潜行",
        acrobatics: "杂技",
        marksmanship: "射击技巧",
        hand_to_hand: "肉搏战",
        tactical: "战术",
        magic: "魔法",
        elemental_control: "元素控制",
        healing: "治疗",
        necromancy: "亡灵术",
        prophecy: "预言",
        shapeshifting: "变形",
        telepathy: "心灵感应",
        telekinesis: "心灵控物",
        alchemy: "炼金术",
        summoning: "召唤术",
        hacking: "黑客技术",
        piloting: "驾驶",
        robotics: "机器人学",
        cybernetics: "控制论",
        nanotech: "纳米技术",
        quantum_physics: "量子物理学",
        ai_programming: "人工智能编程",
        bioengineering: "生物工程",
        time_manipulation: "时间操控",
        energy_weapons: "能量武器",
        crafting: "工艺",
        cooking: "烹饪",
        music: "音乐",
        art: "艺术",
        writing: "写作",
        forgery: "伪造",
        invention: "发明",
        linguistics: "语言学",
        history: "历史",
        science: "科学",
        psychology: "心理学",
        archaeology: "考古学",
        cryptography: "密码学",
        strategy: "战略",
        mythology: "神话学",
        economics: "经济学"
      }
    },
    upgradeForMore: "升级获取更多",
    storiesRemaining: "剩余故事",
    storiesAvailable: "可用故事",
    by: "作者",
    anonymous: "匿名",
    completed: "已完成",
    public: "公开",
    makePublic: "设为公开",
    makePrivate: "设为私密",
    upgradeToMakePublic: "升级以公开故事",
    error: "错误",
    rating: {
      submitted: "评分已提交",
      thankYou: "感谢您对这个故事的评分！",
      failed: "评分提交失败"
    },
    upgrade: {
      required: "需要升级",
      description: "升级您的账户以公开故事并与他人分享。",
      shareStories: "通过高级订阅分享您的故事",
      now: "立即升级"
    },
    startedTime: "开始于 {{time}}",
    storyVisibility: {
      madePublic: "故事已设为公开",
      madePrivate: "故事已设为私密",
      publicDescription: "其他人现在可以查看此故事",
      privateDescription: "此故事现在是私密的"
    },
    stats: {
      tabs: {
        badges: "徽章",
        stories: "故事",
        characters: "角色",
        engagement: "互动"
      },
      badges: {
        loading: "加载徽章中...",
        earned: "已获得:",
        error: {
          title: "错误",
          loadBadges: "加载徽章失败",
          loadProgress: "加载徽章进度失败"
        },
        items: {
          "06491397-1302-45c5-85f7-31e5c46ed3d9": {
            name: "多产作家",
            description: "完成100个故事",
            category: "写作"
          },
          "0b4b084c-4344-4ad0-9b0c-99b03e6fccc8": {
            name: "历史小说家",
            description: "完成3个历史小说故事",
            category: "流派"
          },
          "1a86f197-46e4-4158-bc93-461d83d52b5e": {
            name: "持久作家",
            description: "连续30天以上写回应",
            category: "写作"
          },
          "21a94bad-5405-4d27-ab85-2d4049d708aa": {
            name: "谜题解决者",
            description: "完成10个神秘故事",
            category: "流派"
          },
          "22e8ee37-d737-41ee-be9b-c3aa2e6d6898": {
            name: "对话架构师",
            description: "通过互动贡献10,000字的对话",
            category: "写作"
          },
          "258f5de2-f824-4bf1-adaf-e06df8cb27d0": {
            name: "顶级评论家",
            description: "评价20个角色",
            category: "社区"
          },
          "2fb0b566-d564-4b54-8f74-b39130099161": {
            name: "关系建立者",
            description: "在5个角色之间创建关系",
            category: "角色"
          },
          "59fd8282-02b7-49d9-912b-3137e5b72cf2": {
            name: "病毒式传播",
            description: "一个故事获得1,000+次浏览",
            category: "社交"
          },
          "5a867724-a8ab-4ddd-a85c-b5864a5f8387": {
            name: "深度思考者",
            description: "为3个角色添加详细背景故事",
            category: "角色"
          },
          "66cc4e5d-2a9e-48d7-ae08-4d51993b4693": {
            name: "社交蝴蝶",
            description: "评价20个故事",
            category: "社区"
          },
          "741e00ae-a32d-4495-9191-bd52d90389d2": {
            name: "恐怖爱好者",
            description: "完成20个恐怖故事",
            category: "流派"
          },
          "8a28897b-8993-4b11-a9c6-490703d87066": {
            name: "系列启动者",
            description: "发布多部分系列的第一个故事",
            category: "写作"
          },
          "98ed9a67-4eb9-4c2c-b119-ab270373346a": {
            name: "平衡声音",
            description: "实现更多用户编辑的回应",
            category: "写作"
          },
          "99820441-a9eb-4c9e-a044-80dcf23c0dd6": {
            name: "推荐大师",
            description: "邀请并让10位朋友加入",
            category: "社交"
          },
          "b19a40af-d02c-4e68-9cf2-29ed0609132b": {
            name: "鼓励者",
            description: "对故事给予20+积极反应",
            category: "社区"
          },
          "bb25222d-2bf7-4c3d-9c69-3ee6fdc8f74c": {
            name: "提示大师",
            description: "提供100个独特的用户提示",
            category: "写作"
          },
          "d6178364-f775-483b-ac86-ebcab6f469df": {
            name: "推广者",
            description: "在社交媒体上分享5个故事",
            category: "社交"
          },
          "d9d3b0ad-5512-4f57-afc4-02795f488cea": {
            name: "AI低语者",
            description: "接受500次AI生成的回应",
            category: "写作"
          },
          "dcbda3da-f44f-468e-b650-0ba2b49de57b": {
            name: "角色艺术家",
            description: "为角色生成头像",
            category: "角色"
          },
          "f2f6cb19-eff1-40cb-90e7-d69a13b1cee6": {
            name: "日常作家",
            description: "连续7天创建一个故事",
            category: "写作"
          },
          "f793ac53-913f-4b17-a534-08d34a768544": {
            name: "动态阵容",
            description: "在故事中使用20+不同角色",
            category: "角色"
          },
          "f949c0fc-ffab-4c4b-8cb9-050af34bfd66": {
            name: "实验家",
            description: "在10+不同流派中完成",
            category: "流派"
          }
        }
      },
      storyStats: {
        loading: "加载统计中...",
        totalStories: "故事总数",
        completed: "已完成",
        published: "已发布",
        averageRating: "平均评分",
        categoryRelationships: "故事类别关系",
        primaryCategory: "主要类别",
        secondaryCategory: "次要类别",
        selectCategory: "选择类别",
        genre: "流派",
        themes: "主题",
        environment: "环境",
        noCategoryData: "没有可用的类别数据",
        lessFrequent: "较少频繁",
        moreFrequent: "更加频繁",
        usageDescription: "显示类别在您的故事中一起使用的频率",
        stories: "故事",
        noDataAvailable: "没有可用的数据",
      },
      characterStats: {
        loading: "加载角色统计中...",
        totalCharacters: "角色总数",
        publicCharacters: "公开角色",
        averageRating: "平均评分",
        traitRelationships: "角色特质关系",
        primaryTraitType: "主要特质类型",
        secondaryTraitType: "次要特质类型",
        selectTraitType: "选择特质类型",
        personalityTraits: "性格特点",
        strengths: "优势",
        weaknesses: "劣势",
        skills: "技能",
        noTraitData: "没有可用的特质关系数据",
        lessFrequent: "较少频繁",
        moreFrequent: "更加频繁",
        usageDescription: "显示不同特质在您的角色中一起出现的频率",
        characters: "角色"
      },
      engagementStats: {
        loading: "加载统计中...",
        totalStories: "故事总数",
        avgCustomization: "平均自定义率",
        avgWordCount: "平均字数",
        currentStreak: "当前连续天数",
        days: "天",
        monthlyProgress: "月度进展"
      }
    },
    author: {
      title: '作者简介',
      credits: '故事点数',
      creditsAvailable: '您有 {{count}} 个可用点数',
      memberSince: 'TaleCraft 会员',
      loading: '加载中...',
      recentBadges: '最近徽章',
      noBadgesYet: '尚未获得徽章',
      earnedOn: '获得于 {{date}}',
      more: '更多'
    },
    access: {
      restricted: "访问受限",
      loginRequired: "需要登录",
    }
  }
};
